/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Start_Playing_For_NotesInputs */

const en_read_along_start_playing_for_notes = /** @type {(inputs: Read_Along_Start_Playing_For_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start playing audio to see your notes.`)
};

const es_read_along_start_playing_for_notes = /** @type {(inputs: Read_Along_Start_Playing_For_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza a reproducir audio para ver tus notas.`)
};

/**
* | output |
* | --- |
* | "Start playing audio to see your notes." |
*
* @param {Read_Along_Start_Playing_For_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_start_playing_for_notes = /** @type {((inputs?: Read_Along_Start_Playing_For_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Start_Playing_For_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_start_playing_for_notes(inputs)
	return en_read_along_start_playing_for_notes(inputs)
});